import React from 'react';
import { Tween, Timeline } from 'react-gsap';
import PropTypes from 'prop-types';
import { t } from '../../translations';

// eslint-disable-next-line react/prop-types
const PulseButton = (
  { pulse, loaded, clearPulse, src, onLoaded, onClick, className, label },
  ref
) => {
  return (
    <button
      ref={ref}
      className={`gss-button ${className}`}
      disabled={!pulse && !loaded}
      onClick={!pulse && loaded ? onClick : null}
      id={'next-arrow-button'}
      aria-label={label}
    >
      <span
        className={'magic-overlay'}
        style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}
      />
      {pulse && (
        <Timeline
          target={
            <object type={'image/svg+xml'} data={src} alt={t('CouldNotLoad')} tabIndex="-1" />
          }
          repeat={1}
          onComplete={clearPulse}
        >
          <Tween
            to={{ scale: 1.2, boxShadow: '0 0 0 0px rgba(131, 218, 240, 1)' }}
            duration={0.3}
            ease={'Power0.easeInOut'}
          />
          <Tween
            to={{ scale: 1, boxShadow: '0 0 0 55px rgba(131, 218, 240, 0)' }}
            duration={0.3}
            ease={'Power0.easeInOut'}
          />
        </Timeline>
      )}

      {!pulse && !loaded && (
        <Tween
          from={{ opacity: 0, scale: 0 }}
          to={{ opacity: 1, scale: 1 }}
          duration={0.5}
          ease={'Back.easeOut'}
          onComplete={onLoaded}
        >
          <object type={'image/svg+xml'} data={src} alt="" tabIndex="-1" />
        </Tween>
      )}

      {!pulse && loaded && <object type={'image/svg+xml'} data={src} alt="" tabIndex="-1" />}
    </button>
  );
};

export default React.forwardRef(PulseButton);

PulseButton.propTypes = {
  pulse: PropTypes.bool,
  loaded: PropTypes.bool,
  clearPulse: PropTypes.func,
  src: PropTypes.string,
  onLoaded: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.array,
  label: PropTypes.string
};
